var _rect, _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle4, _circle5, _rect12, _rect13, _circle6, _rect14, _rect15, _circle7, _rect16, _rect17, _circle8, _rect18, _g, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstrucaoProt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 364,
    viewBox: "0 0 444 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0765,
    y: 42.4212,
    width: 385.875,
    height: 319.931,
    rx: 7.06722,
    stroke: "#D9DBE3",
    strokeWidth: 1.54556
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.7603,
    y1: 70.4538,
    x2: 397.88,
    y2: 70.4538,
    stroke: "#D9DBE3",
    strokeWidth: 1.54556
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 95.567,
    y1: 70.5,
    x2: 95.567,
    y2: 362.096,
    stroke: "#D9DBE3",
    strokeWidth: 1.54556
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 397.88,
    y1: 96.4993,
    x2: 95.0603,
    y2: 96.4993,
    stroke: "#D9DBE3",
    strokeWidth: 1.54556
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 397.88,
    y1: 323.515,
    x2: 95.0603,
    y2: 323.515,
    stroke: "#D9DBE3",
    strokeWidth: 1.54556
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4907,
    cy: 56.0273,
    r: 4.73761,
    stroke: "#D9DBE3",
    strokeWidth: 1.47
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5568,
    cy: 56.0273,
    r: 4.73761,
    stroke: "#D9DBE3",
    strokeWidth: 1.47
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.623,
    cy: 56.0273,
    r: 4.73761,
    stroke: "#D9DBE3",
    strokeWidth: 1.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2461 86.4873V93.8729H45.916V88.7489L44.2328 92.424H43.0675L41.396 88.7371V93.8729H40.0659V86.4873H41.808L43.6795 90.6925L45.5628 86.4873H47.2461Z",
    fill: "#2F3139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1958 92.4476V93.5548C52.9996 93.6726 52.6897 93.7747 52.2659 93.8611C51.85 93.9396 51.4145 93.9789 50.9594 93.9789C50.0334 93.9789 49.3664 93.7433 48.9583 93.2721C48.5581 92.801 48.358 92.0235 48.358 90.9398C48.358 89.8954 48.5699 89.1337 48.9936 88.6547C49.4174 88.1756 50.0883 87.9361 51.0064 87.9361C51.8932 87.9361 52.5209 88.1207 52.8898 88.4898C53.2586 88.8588 53.443 89.491 53.443 90.3862C53.443 90.5511 53.4391 90.7043 53.4312 90.8456C53.4234 90.9791 53.4077 91.1676 53.3841 91.411H49.7352C49.743 91.8979 49.849 92.2395 50.053 92.4358C50.2649 92.6321 50.6376 92.7303 51.1712 92.7303C51.5244 92.7303 51.8892 92.7028 52.2659 92.6478C52.6426 92.5929 52.9525 92.5261 53.1958 92.4476ZM51.0064 89.1258C50.5278 89.1258 50.1943 89.2201 50.0059 89.4085C49.8254 89.597 49.7352 89.9386 49.7352 90.4333H52.1953V90.186C52.1874 89.7855 52.0972 89.5106 51.9246 89.3614C51.7519 89.2044 51.4459 89.1258 51.0064 89.1258Z",
    fill: "#2F3139"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1986 86.0397H59.564V93.8729H58.3634L58.281 93.331H58.2222C58.0024 93.5509 57.7396 93.7158 57.4335 93.8258C57.1353 93.9278 56.7901 93.9789 56.3977 93.9789C55.6208 93.9789 55.0637 93.7433 54.7263 93.2721C54.3967 92.801 54.2319 92.0275 54.2319 90.9516C54.2319 89.8915 54.4359 89.1258 54.844 88.6547C55.2599 88.1756 55.9426 87.9361 56.8921 87.9361C57.1432 87.9361 57.3786 87.9558 57.5983 87.995C57.8259 88.0264 58.026 88.0736 58.1986 88.1364V86.0397ZM57.0804 89.1612C56.4762 89.1612 56.076 89.2829 55.8798 89.5263C55.6915 89.7698 55.5973 90.2449 55.5973 90.9516C55.5973 91.6348 55.6797 92.0981 55.8445 92.3416C56.0171 92.585 56.3663 92.7067 56.8921 92.7067C57.1432 92.7067 57.3786 92.6832 57.5983 92.6361C57.818 92.5811 58.0181 92.5026 58.1986 92.4005V89.3614C58.0338 89.2907 57.8612 89.2397 57.6807 89.2083C57.5002 89.1769 57.3001 89.1612 57.0804 89.1612Z",
    fill: "#2F3139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2357 89.1965H60.4588V88.0539H61.2357V87.995C61.2357 87.304 61.3926 86.7857 61.7065 86.4402C62.0204 86.0946 62.4951 85.9219 63.1307 85.9219C63.2798 85.9219 63.4289 85.9297 63.578 85.9454C63.7271 85.9611 63.9037 85.9886 64.1077 86.0279V87.1116C64.0057 87.0959 63.8919 87.0841 63.7664 87.0762C63.6408 87.0605 63.527 87.0527 63.425 87.0527C63.1111 87.0527 62.8953 87.1116 62.7776 87.2294C62.6599 87.3472 62.6011 87.567 62.6011 87.889V88.0539H63.9312V89.1965H62.6011V93.8729H61.2357V89.1965ZM66.2971 86.0397V93.8729H64.9317V86.0397H66.2971Z",
    fill: "#2F3139"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9036 90.9516C72.9036 92.051 72.6917 92.8324 72.268 93.2957C71.8521 93.7512 71.138 93.9789 70.1257 93.9789C69.0977 93.9789 68.3758 93.7551 67.9599 93.3075C67.544 92.852 67.336 92.0667 67.336 90.9516C67.336 89.8601 67.5479 89.0866 67.9716 88.6311C68.3954 88.1678 69.1134 87.9361 70.1257 87.9361C71.1458 87.9361 71.8638 88.1639 72.2797 88.6193C72.6956 89.0669 72.9036 89.8444 72.9036 90.9516ZM68.7014 90.9398C68.7014 91.6623 68.7917 92.1374 68.9722 92.3651C69.1526 92.5929 69.5371 92.7067 70.1257 92.7067C70.6985 92.7067 71.0752 92.5929 71.2557 92.3651C71.444 92.1295 71.5382 91.6544 71.5382 90.9398C71.5382 90.2095 71.4479 89.7305 71.2674 89.5028C71.0948 89.275 70.7142 89.1612 70.1257 89.1612C69.545 89.1612 69.1605 89.279 68.9722 89.5145C68.7917 89.7501 68.7014 90.2252 68.7014 90.9398Z",
    fill: "#2F3139"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1452 88.0539H81.6401L80.0511 93.8729H78.4503L77.4144 89.9386L76.4845 93.8729H74.9073L73.3182 88.0539H74.8131L75.7194 92.6125L76.8023 88.0539H78.1089L79.2389 92.6125L80.1452 88.0539Z",
    fill: "#2F3139"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8803 94.9294C29.8803 93.2293 31.2586 91.851 32.9587 91.851C34.6589 91.851 36.0371 93.2293 36.0371 94.9294C36.0371 96.6296 34.6589 98.0078 32.9587 98.0078C31.2586 98.0078 29.8803 96.6296 29.8803 94.9294Z",
    fill: "#2047AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8803 84.9722C29.8803 83.272 31.2586 81.8938 32.9587 81.8938C34.6589 81.8938 36.0371 83.272 36.0371 84.9722C36.0371 86.6723 34.6589 88.0506 32.9587 88.0506C31.2586 88.0506 29.8803 86.6723 29.8803 84.9722Z",
    fill: "#2047AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9231 94.9294C19.9231 93.2293 21.3013 91.851 23.0015 91.851C24.7016 91.851 26.0799 93.2293 26.0799 94.9294C26.0799 96.6296 24.7016 98.0078 23.0015 98.0078C21.3013 98.0078 19.9231 96.6296 19.9231 94.9294Z",
    fill: "#2047AE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9231 84.9722C19.9231 83.272 21.3013 81.8938 23.0015 81.8938C24.7016 81.8938 26.0799 83.272 26.0799 84.9722C26.0799 86.6723 24.7016 88.0506 23.0015 88.0506C21.3013 88.0506 19.9231 86.6723 19.9231 84.9722Z",
    fill: "#2047AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0371 95.013L19.9231 95.013L19.9231 84.8734L36.0371 84.8734L36.0371 95.013Z",
    fill: "#2047AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9967 98.0078L22.9483 98.0078L22.9483 81.8938L32.9967 81.8938L32.9967 98.0078Z",
    fill: "#2047AE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.161 93.9633H24.4547C24.1766 93.9633 23.9512 93.7378 23.9512 93.4597V87.2053C23.9512 86.7455 24.5168 86.5262 24.8267 86.8659L30.533 93.1203C30.8279 93.4436 30.5986 93.9633 30.161 93.9633Z",
    fill: "#4676FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7985 93.9633H31.5047C31.7828 93.9633 32.0083 93.7378 32.0083 93.4597V87.2053C32.0083 86.7455 31.4427 86.5262 31.1327 86.8659L25.4265 93.1203C25.1316 93.4436 25.3609 93.9633 25.7985 93.9633Z",
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9231,
    y: 115.039,
    width: 68.5742,
    height: 11.429,
    rx: 1.47,
    fill: "#F0F2F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.78,
    y: 115.219,
    width: 108.78,
    height: 10.78,
    rx: 1.47,
    fill: "#D9DBE3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 223.44,
    y: 115.219,
    width: 19.6,
    height: 10.78,
    rx: 1.47,
    fill: "#D9DBE3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108.78,
    y: 335.359,
    width: 24.001,
    height: 16.0006,
    rx: 8.00032,
    fill: "#F0F2F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 236.18,
    y: 335.359,
    width: 67.4313,
    height: 16.0006,
    rx: 8.00032,
    fill: "#F0F2F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 310.469,
    y: 335.359,
    width: 74.2887,
    height: 16.0006,
    rx: 8.00032,
    fill: "#4676FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.78,
    y: 135.797,
    width: 7.84,
    height: 6.86,
    rx: 1.47,
    fill: "#D9DBE3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 135.797,
    width: 57.82,
    height: 6.86,
    rx: 1.47,
    fill: "#D9DBE3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9231,
    y: 135.609,
    width: 68.5742,
    height: 11.429,
    rx: 1.47,
    fill: "#F0F2F5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 153.053,
    width: 275.38,
    height: 22.54,
    rx: 3.43,
    fill: "#F0F2F5",
    stroke: "#D9DBE3",
    strokeWidth: 0.98
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.785,
    cy: 164.191,
    r: 5.25735,
    fill: "#F0F2F5",
    stroke: "#D9DBE3",
    strokeWidth: 0.914322
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.785,
    cy: 164.194,
    r: 3.42871,
    fill: "#4676FA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 135.357,
    y: 160.766,
    width: 90.2893,
    height: 6.85742,
    rx: 1.1429,
    fill: "#D9DBE3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 180.49,
    width: 275.38,
    height: 22.54,
    rx: 3.43,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.98
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.785,
    cy: 191.629,
    r: 5.25735,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.914322
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 188,
    width: 45,
    height: 7,
    rx: 1.1429,
    fill: "#D9DBE3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 207.928,
    width: 275.38,
    height: 22.54,
    rx: 3.43,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.98
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.785,
    cy: 219.05,
    r: 5.25735,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.914322
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 135.357,
    y: 215.617,
    width: 90.2893,
    height: 6.85742,
    rx: 1.1429,
    fill: "#D9DBE3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 235.373,
    width: 275.38,
    height: 22.54,
    rx: 3.43,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.98
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.785,
    cy: 246.488,
    r: 5.25735,
    fill: "white",
    stroke: "#D9DBE3",
    strokeWidth: 0.914322
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 243,
    width: 74,
    height: 7,
    rx: 1.1429,
    fill: "#D9DBE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3912_6090)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.46,
    y: 0.664062,
    width: 316.54,
    height: 102.566,
    rx: 7.10889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.975,
    y: 1.17925,
    width: 315.51,
    height: 101.536,
    rx: 6.5937,
    stroke: "#D9DBE3",
    strokeWidth: 1.03037
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 132.418,
    y: 50.0625,
    width: 70.7704,
    height: 13.8089,
    rx: 1.72611,
    fill: "#ECF1FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 363.716,
    y: 39.7109,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#CFDAFA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 363.716,
    y: 60.4219,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#ECF1FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 210.092,
    y: 39.7109,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#CFDAFA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 210.092,
    y: 60.4141,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#ECF1FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 286.904,
    y: 19,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#CFDAFA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 286.904,
    y: 39.7188,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#CFDAFA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 286.904,
    y: 60.4219,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#ECF1FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 286.904,
    y: 81.1406,
    width: 70.2106,
    height: 13.8089,
    rx: 1.72611,
    fill: "#ECF1FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.283 48.9859L168.283 34.0555C168.283 32.3479 168.962 30.7103 170.169 29.5029C171.376 28.2955 173.014 27.6172 174.722 27.6172L229.395 27.6172C231.103 27.6172 232.74 28.2955 233.948 29.5029C235.155 30.7103 235.833 32.3479 235.833 34.0555L235.833 40.0277",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M237.263 38.597C237.239 38.5826 237.211 38.5751 237.182 38.575C237.182 38.575 237.182 38.575 237.182 38.575L237.263 38.597ZM237.263 38.597C237.288 38.6113 237.308 38.6319 237.322 38.6567M237.263 38.597L237.322 38.6567M237.322 38.6567C237.336 38.6815 237.343 38.7095 237.343 38.738M237.322 38.6567L237.343 38.738M237.343 38.738C237.343 38.7664 237.335 38.7943 237.32 38.8187M237.343 38.738L237.32 38.8187M237.32 38.8187L235.957 41.0904C235.943 41.1142 235.923 41.1339 235.898 41.1476C235.874 41.1613 235.847 41.1685 235.819 41.1685C235.791 41.1685 235.764 41.1613 235.74 41.1476C235.716 41.1339 235.695 41.1142 235.681 41.0904C235.681 41.0904 235.681 41.0904 235.681 41.0904L234.318 38.8187L237.32 38.8187ZM234.296 38.738C234.296 38.7664 234.304 38.7942 234.318 38.8186L234.296 38.738ZM234.296 38.738C234.295 38.7095 234.302 38.6815 234.316 38.6567M234.296 38.738L234.316 38.6567M234.316 38.6567C234.33 38.6319 234.351 38.6113 234.375 38.597M234.316 38.6567L234.375 38.597M234.375 38.597C234.4 38.5826 234.428 38.575 234.456 38.575L234.375 38.597Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.88 49.9638C169.88 50.2822 169.786 50.5934 169.609 50.8581C169.432 51.1228 169.181 51.3291 168.886 51.4509C168.592 51.5727 168.269 51.6046 167.957 51.5425C167.644 51.4804 167.357 51.3271 167.132 51.102C166.907 50.8769 166.754 50.5901 166.692 50.2779C166.63 49.9656 166.662 49.642 166.783 49.3479C166.905 49.0538 167.112 48.8024 167.376 48.6255C167.641 48.4487 167.952 48.3543 168.271 48.3543C168.697 48.3543 169.107 48.5238 169.409 48.8257C169.711 49.1276 169.88 49.537 169.88 49.9638Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M255.891 39.4836L255.891 15.9227C255.891 14.2151 256.569 12.5775 257.777 11.3701C258.984 10.1627 260.622 9.48438 262.329 9.48438L317.983 9.48438C319.691 9.48438 321.328 10.1627 322.536 11.3701C323.743 12.5775 324.421 14.2151 324.421 15.9227L324.421 18.5464",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.851 18.7376C325.827 18.7232 325.799 18.7157 325.77 18.7156C325.77 18.7156 325.77 18.7156 325.77 18.7156L325.851 18.7376ZM325.851 18.7376C325.876 18.7519 325.896 18.7725 325.91 18.7973M325.851 18.7376L325.91 18.7973M325.91 18.7973C325.924 18.8221 325.931 18.8501 325.931 18.8786M325.91 18.7973L325.931 18.8786M325.931 18.8786C325.931 18.9071 325.923 18.9349 325.908 18.9593M325.931 18.8786L325.908 18.9593M325.908 18.9593L324.545 21.231C324.531 21.2548 324.511 21.2746 324.487 21.2883C324.462 21.302 324.435 21.3092 324.407 21.3092C324.379 21.3092 324.352 21.302 324.328 21.2883C324.304 21.2746 324.284 21.2549 324.269 21.231C324.269 21.231 324.269 21.231 324.269 21.231L322.907 18.9593L325.908 18.9593ZM322.884 18.8786C322.884 18.907 322.892 18.9349 322.907 18.9593L322.884 18.8786ZM322.884 18.8786C322.883 18.8501 322.891 18.8221 322.905 18.7973M322.884 18.8786L322.905 18.7973M322.905 18.7973C322.919 18.7725 322.939 18.7519 322.964 18.7376M322.905 18.7973L322.964 18.7376M322.964 18.7376C322.988 18.7232 323.016 18.7157 323.045 18.7156L322.964 18.7376Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.488 39.4717C257.488 39.79 257.394 40.1012 257.217 40.3659C257.04 40.6306 256.789 40.8369 256.494 40.9587C256.2 41.0805 255.877 41.1124 255.564 41.0503C255.252 40.9882 254.965 40.8349 254.74 40.6098C254.515 40.3847 254.362 40.0979 254.3 39.7857C254.238 39.4734 254.27 39.1498 254.391 38.8557C254.513 38.5616 254.72 38.3102 254.984 38.1333C255.249 37.9565 255.56 37.8621 255.878 37.8621C256.305 37.8621 256.715 38.0317 257.017 38.3335C257.318 38.6354 257.488 39.0448 257.488 39.4717Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.283 64.767L168.283 79.6954C168.283 81.4027 168.961 83.0401 170.168 84.2473C171.375 85.4546 173.013 86.1328 174.72 86.1328L229.385 86.1328C231.092 86.1328 232.73 85.4546 233.937 84.2473C235.144 83.0401 235.822 81.4027 235.822 79.6954L235.822 73.724",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.252 75.1452C237.227 75.1596 237.199 75.1671 237.171 75.1672C237.171 75.1672 237.171 75.1672 237.171 75.1672L237.252 75.1452ZM237.252 75.1452C237.276 75.1309 237.297 75.1103 237.311 75.0855M237.252 75.1452L237.311 75.0855M237.311 75.0855C237.325 75.0608 237.332 75.0327 237.331 75.0043M237.311 75.0855L237.331 75.0043M237.331 75.0043C237.331 74.9758 237.323 74.948 237.309 74.9235M237.331 75.0043L237.309 74.9235M237.309 74.9235L235.946 72.6522C235.932 72.6284 235.911 72.6086 235.887 72.5949C235.863 72.5812 235.836 72.5741 235.808 72.5741C235.78 72.5741 235.753 72.5812 235.729 72.5949C235.704 72.6086 235.684 72.6284 235.67 72.6522L234.307 74.9235C234.293 74.948 234.285 74.9758 234.285 75.0043C234.284 75.0327 234.291 75.0608 234.305 75.0855C234.319 75.1103 234.34 75.1309 234.364 75.1452C234.389 75.1596 234.417 75.1671 234.445 75.1672L237.309 74.9235Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.88 63.7859C169.88 63.4676 169.786 63.1565 169.609 62.8918C169.432 62.6272 169.181 62.4209 168.887 62.2991C168.593 62.1773 168.269 62.1454 167.957 62.2075C167.645 62.2696 167.358 62.4229 167.133 62.6479C166.908 62.873 166.754 63.1598 166.692 63.472C166.63 63.7841 166.662 64.1077 166.784 64.4018C166.906 64.6958 167.112 64.9472 167.377 65.124C167.641 65.3009 167.952 65.3953 168.271 65.3953C168.698 65.3953 169.107 65.2257 169.409 64.9239C169.711 64.6221 169.88 64.2127 169.88 63.7859Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.588 67.4375L286.904 67.4375",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M286.224 68.7045C286.21 68.68 286.202 68.6521 286.202 68.6236C286.202 68.6236 286.202 68.6236 286.202 68.6236L286.224 68.7045ZM286.224 68.7045C286.238 68.7291 286.259 68.7495 286.284 68.7635M286.224 68.7045L286.284 68.7635M286.284 68.7635C286.308 68.7775 286.336 68.7847 286.365 68.7843M286.284 68.7635L286.365 68.7843M286.365 68.7843C286.393 68.784 286.421 68.7761 286.446 68.7615M286.365 68.7843L286.446 68.7615M286.446 68.7615L288.717 67.3987C288.741 67.3844 288.761 67.3642 288.774 67.34C288.788 67.3158 288.795 67.2885 288.795 67.2607C288.795 67.2329 288.788 67.2056 288.774 67.1814C288.761 67.1573 288.741 67.137 288.717 67.1227L286.446 65.7603C286.421 65.7457 286.393 65.7378 286.365 65.7374C286.336 65.7371 286.308 65.7443 286.284 65.7583C286.259 65.7723 286.238 65.7927 286.224 65.8172C286.21 65.8418 286.202 65.8698 286.202 65.8982L286.446 68.7615Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M280.79 67.3406C280.79 67.0223 280.696 66.7112 280.519 66.4465C280.342 66.1819 280.091 65.9756 279.797 65.8538C279.503 65.732 279.179 65.7001 278.867 65.7622C278.555 65.8243 278.268 65.9776 278.043 66.2026C277.818 66.4277 277.665 66.7145 277.603 67.0266C277.54 67.3388 277.572 67.6624 277.694 67.9565C277.816 68.2505 278.022 68.5019 278.287 68.6787C278.551 68.8556 278.863 68.9499 279.181 68.9499C279.608 68.9499 280.017 68.7804 280.319 68.4786C280.621 68.1768 280.79 67.7674 280.79 67.3406Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M324.212 33.5592L324.212 40.875",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M322.942 40.1907C322.967 40.1764 322.995 40.1688 323.023 40.1688C323.023 40.1688 323.023 40.1688 323.023 40.1688L322.942 40.1907ZM322.942 40.1907C322.918 40.205 322.898 40.2257 322.883 40.2504M322.942 40.1907L322.883 40.2504M322.883 40.2504C322.869 40.2752 322.862 40.3032 322.863 40.3317M322.883 40.2504L322.863 40.3317M322.863 40.3317C322.863 40.3601 322.871 40.388 322.886 40.4124M322.863 40.3317L322.886 40.4124M322.886 40.4124L324.248 42.6838C324.263 42.7076 324.283 42.7273 324.307 42.741C324.331 42.7547 324.358 42.7619 324.386 42.7619C324.414 42.7619 324.441 42.7547 324.466 42.741C324.49 42.7273 324.51 42.7076 324.524 42.6838L325.887 40.4124C325.901 40.388 325.909 40.3601 325.91 40.3317C325.91 40.3032 325.903 40.2752 325.889 40.2504C325.875 40.2257 325.854 40.205 325.83 40.1907C325.805 40.1764 325.777 40.1688 325.749 40.1688L322.886 40.4124Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M324.303 34.7546C324.621 34.7546 324.933 34.6602 325.197 34.4834C325.462 34.3066 325.668 34.0552 325.79 33.7612C325.912 33.4671 325.944 33.1435 325.882 32.8313C325.82 32.5191 325.666 32.2324 325.441 32.0073C325.216 31.7823 324.929 31.629 324.617 31.5669C324.305 31.5048 323.981 31.5367 323.687 31.6585C323.393 31.7803 323.142 31.9865 322.965 32.2512C322.788 32.5158 322.694 32.827 322.694 33.1453C322.694 33.5721 322.863 33.9815 323.165 34.2833C323.467 34.5851 323.876 34.7546 324.303 34.7546Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M321.378 74.6608L321.378 81.9766",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.109 81.2923C320.134 81.2779 320.162 81.2704 320.19 81.2703C320.19 81.2703 320.19 81.2703 320.19 81.2703L320.109 81.2923ZM320.109 81.2923C320.085 81.3066 320.065 81.3272 320.05 81.352M320.109 81.2923L320.05 81.352M320.05 81.352C320.036 81.3767 320.029 81.4048 320.03 81.4332M320.05 81.352L320.03 81.4332M320.03 81.4332C320.03 81.4617 320.038 81.4895 320.052 81.514M320.03 81.4332L320.052 81.514M320.052 81.514L321.415 83.7853C321.43 83.8091 321.45 83.8289 321.474 83.8426C321.498 83.8563 321.525 83.8634 321.553 83.8634C321.581 83.8634 321.608 83.8563 321.633 83.8426C321.657 83.8289 321.677 83.8092 321.691 83.7853L323.054 81.514C323.068 81.4895 323.076 81.4617 323.077 81.4332C323.077 81.4048 323.07 81.3767 323.056 81.352C323.042 81.3272 323.021 81.3066 322.997 81.2923C322.972 81.2779 322.944 81.2704 322.916 81.2703L320.052 81.514Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M321.47 75.8562C321.788 75.8562 322.1 75.7618 322.364 75.585C322.629 75.4081 322.835 75.1568 322.957 74.8627C323.079 74.5687 323.111 74.2451 323.049 73.9329C322.987 73.6207 322.833 73.334 322.608 73.1089C322.383 72.8838 322.096 72.7305 321.784 72.6684C321.472 72.6063 321.148 72.6382 320.854 72.76C320.56 72.8818 320.309 73.0881 320.132 73.3528C319.955 73.6174 319.861 73.9286 319.861 74.2469C319.861 74.6737 320.03 75.083 320.332 75.3848C320.634 75.6866 321.043 75.8562 321.47 75.8562Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M356.713 46.4141L364.029 46.414",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M363.348 47.6889C363.334 47.6644 363.327 47.6364 363.326 47.608C363.326 47.608 363.326 47.608 363.326 47.6079L363.348 47.6889ZM363.348 47.6889C363.363 47.7135 363.383 47.7338 363.408 47.7479M363.348 47.6889L363.408 47.7479M363.408 47.7479C363.433 47.7619 363.461 47.7691 363.489 47.7687M363.408 47.7479L363.489 47.7687M363.489 47.7687C363.518 47.7684 363.546 47.7605 363.57 47.7458M363.489 47.7687L363.57 47.7458M363.57 47.7458L365.841 46.3831C365.865 46.3688 365.885 46.3486 365.899 46.3244C365.912 46.3002 365.92 46.2729 365.92 46.2451C365.92 46.2173 365.912 46.19 365.899 46.1658C365.885 46.1416 365.865 46.1214 365.841 46.1071L363.57 44.7447C363.546 44.7301 363.518 44.7222 363.489 44.7218C363.461 44.7215 363.433 44.7287 363.408 44.7427C363.383 44.7567 363.363 44.777 363.348 44.8016C363.334 44.8262 363.327 44.8541 363.326 44.8826L363.57 47.7458Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M357.915 46.3328C357.915 46.0145 357.82 45.7033 357.644 45.4387C357.467 45.174 357.215 44.9678 356.921 44.846C356.627 44.7242 356.304 44.6923 355.991 44.7544C355.679 44.8165 355.393 44.9698 355.167 45.1948C354.942 45.4199 354.789 45.7066 354.727 46.0188C354.665 46.331 354.697 46.6546 354.819 46.9487C354.94 47.2427 355.147 47.4941 355.411 47.6709C355.676 47.8477 355.987 47.9421 356.305 47.9421C356.732 47.9421 357.142 47.7726 357.443 47.4708C357.745 47.169 357.915 46.7596 357.915 46.3328Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M357.719 88.25L389.91 88.25C391.618 88.25 393.255 87.5717 394.463 86.3643C395.67 85.1568 396.349 83.5192 396.349 81.8117L396.349 74.2119",
    stroke: "#4676FA",
    strokeWidth: 1.28766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.905 75.2234C394.929 75.2377 394.957 75.2453 394.986 75.2453C394.986 75.2453 394.986 75.2453 394.986 75.2453L394.905 75.2234ZM394.905 75.2234C394.88 75.209 394.86 75.1884 394.846 75.1636M394.905 75.2234L394.846 75.1636M394.846 75.1636C394.832 75.1389 394.824 75.1108 394.825 75.0823M394.846 75.1636L394.825 75.0823M394.825 75.0823C394.825 75.0539 394.833 75.026 394.848 75.0016M394.825 75.0823L394.848 75.0016M394.848 75.0016L396.211 72.7299C396.225 72.7061 396.245 72.6864 396.269 72.6727C396.294 72.659 396.321 72.6518 396.349 72.6518C396.376 72.6518 396.404 72.659 396.428 72.6727C396.452 72.6864 396.472 72.7061 396.487 72.7299C396.487 72.7299 396.487 72.7299 396.487 72.7299L397.849 75.0016L394.848 75.0016ZM397.872 75.0823C397.872 75.0539 397.864 75.0261 397.849 75.0017L397.872 75.0823ZM397.872 75.0823C397.872 75.1108 397.865 75.1389 397.851 75.1636M397.872 75.0823L397.851 75.1636M397.851 75.1636C397.837 75.1884 397.817 75.209 397.792 75.2234M397.851 75.1636L397.792 75.2234M397.792 75.2234C397.768 75.2377 397.74 75.2453 397.711 75.2453L397.792 75.2234Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M357.719 86.6433C358.037 86.6433 358.348 86.7377 358.613 86.9146C358.878 87.0915 359.084 87.3428 359.206 87.6369C359.328 87.9311 359.359 88.2547 359.297 88.5669C359.235 88.8791 359.082 89.1659 358.857 89.391C358.632 89.6161 358.345 89.7694 358.033 89.8316C357.721 89.8937 357.397 89.8618 357.103 89.74C356.809 89.6181 356.557 89.4118 356.38 89.1471C356.204 88.8824 356.109 88.5712 356.109 88.2529C356.109 87.826 356.279 87.4166 356.581 87.1148C356.882 86.8129 357.292 86.6433 357.719 86.6433Z",
    fill: "#4676FA",
    stroke: "#4676FA",
    strokeWidth: 0.321915
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M390.443 140.797V176.655H426.301C426.301 156.851 410.247 140.797 390.443 140.797Z",
    fill: "#4676FA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M439.303 131.062H411.073V159.292H439.303V131.062Z",
    fill: "#ECF1FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M411.332 134.477C411.393 134.407 411.455 134.337 411.514 134.266C411.741 133.998 411.962 133.724 412.172 133.442C412.193 133.414 412.212 133.385 412.233 133.356C412.423 133.098 412.605 132.833 412.781 132.564C412.833 132.484 412.885 132.403 412.936 132.322C413.107 132.05 413.273 131.773 413.429 131.491C413.446 131.46 413.465 131.429 413.482 131.398C413.652 131.087 413.809 130.769 413.96 130.448C414 130.363 414.037 130.277 414.076 130.192C414.196 129.924 414.309 129.652 414.416 129.376C414.443 129.308 414.471 129.24 414.497 129.171C414.621 128.838 414.735 128.499 414.839 128.156C414.863 128.076 414.884 127.995 414.907 127.915C414.988 127.633 415.062 127.348 415.128 127.06C415.149 126.971 415.171 126.883 415.19 126.792C415.266 126.437 415.333 126.079 415.387 125.717C415.396 125.658 415.402 125.597 415.41 125.537C415.453 125.224 415.488 124.909 415.513 124.591C415.522 124.491 415.53 124.391 415.536 124.29C415.561 123.915 415.577 123.538 415.577 123.156H406.96C406.96 124.778 406.501 126.367 405.636 127.74C404.772 129.112 403.537 130.213 402.075 130.914L405.815 138.691C406.137 138.536 406.451 138.368 406.761 138.194C406.844 138.147 406.927 138.099 407.009 138.051C407.271 137.898 407.528 137.739 407.781 137.574C407.829 137.542 407.879 137.513 407.927 137.481C408.218 137.285 408.503 137.079 408.782 136.867C408.852 136.813 408.921 136.758 408.99 136.703C409.215 136.526 409.435 136.344 409.65 136.158C409.712 136.104 409.775 136.051 409.836 135.997C410.096 135.764 410.349 135.523 410.595 135.275C410.646 135.224 410.694 135.17 410.744 135.118C410.946 134.909 411.142 134.695 411.332 134.477Z",
    fill: "#20BF6B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0036 315.666C55.7789 312.332 57.7577 304.947 54.4233 299.171C51.0889 293.396 43.704 291.417 37.9286 294.752C32.1533 298.086 30.1745 305.471 33.5089 311.246C36.8433 317.022 44.2282 319 50.0036 315.666Z",
    fill: "#ECF1FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0168 306.228C31.5987 307.624 28.7251 308.002 26.0282 307.28C23.3312 306.557 21.0317 304.793 19.6357 302.375C18.2396 299.957 17.8613 297.083 18.5839 294.386C19.3066 291.689 21.071 289.39 23.4891 287.994L18.2251 278.876C15.4877 280.458 13.1418 282.637 11.3616 285.25C9.5813 287.863 8.41239 290.844 7.9416 293.97C7.4708 297.097 7.7102 300.289 8.64205 303.311C9.57389 306.332 11.1742 309.105 13.3243 311.423C15.4744 313.741 18.119 315.546 21.0618 316.702C24.0046 317.859 27.17 318.337 30.3232 318.103C33.4763 317.869 36.5362 316.927 39.2757 315.348C42.0152 313.77 44.364 311.594 46.1477 308.983L37.4401 303.04C36.5541 304.347 35.3838 305.437 34.0168 306.228Z",
    fill: "#4676FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3912_6090",
    x: 124.46,
    y: 0.664062,
    width: 318.601,
    height: 104.623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.06075,
    dy: 2.06075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3912_6090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3912_6090",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstrucaoProt);
export default __webpack_public_path__ + "static/media/construcao-prot.21829d50d6c4246881276ce7a3deff21.svg";
export { ForwardRef as ReactComponent };